import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PartnerLeadRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const partnerData = {
      partner_id: params.get("partner_id"),
      product: params.get("product"),
      lead_ref: params.get("lead_ref"),
      channel: params.get("channel"),
      sig: params.get("sig"),
      ts: params.get("ts"),
    };

    // Check that the partner URL actually contains parameters
    const hasPartnerParams = Object.values(partnerData).some(
      (value) => value !== null && value !== ""
    );

    if (hasPartnerParams) {
      sessionStorage.setItem(
        "partnerLeadParams",
        JSON.stringify(partnerData)
      );

      navigate("/login", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [location.search, navigate]);

  return null;
};

export default PartnerLeadRedirect;